module.exports = __webpack_public_path__ + "img/h-1.9a82d95e.png";